(function () {
  var SECTION_SELECTOR = '[data-smp-judgeme-proof]';
  var HOST_SELECTOR = '[data-scentell-judgeme-host]';
  var WIDGET_SELECTOR = '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-widget, .jdgm-rev-widg, .jdgm-carousel-wrapper';
  var REVIEW_SELECTOR = [
    '.jdgm-rev',
    '.jm-review-item',
    '.jdgm-carousel-item',
    '.jdgm-carousel__item',
    '.jdgm-all-reviews__review'
  ].join(', ');
  var AUTHOR_SELECTOR = [
    '.jdgm-rev__author',
    '.jm-review-item__author-name',
    '.jm-review-item__reviewer-name',
    '.jm-reviewer-info__name',
    '.jdgm-carousel-item__reviewer-name',
    '.jdgm-carousel__item-reviewer-name',
    '.jdgm-all-reviews__reviewer-name',
    '[itemprop="author"]'
  ].join(', ');
  var AUTHOR_BLOCK_SELECTOR = [
    '.jdgm-row-profile',
    '.jm-review-item__author',
    '.jm-review-item__reviewer',
    '.jm-reviewer-info',
    '.jdgm-carousel-item__reviewer',
    '.jdgm-carousel__item-reviewer',
    '.jdgm-all-reviews__reviewer'
  ].join(', ');
  var RATING_SELECTOR = [
    '.jdgm-rev__rating',
    '.jm-review-item__rating',
    '.jm-star-rating',
    '.jdgm-carousel-item__review-rating',
    '.jdgm-carousel__item-review-rating',
    '.jdgm-all-reviews__review-rating'
  ].join(', ');
  var RATING_ROW_SELECTOR = [
    '.scentell-jdgm-rating-date-row',
    '.jdgm-row-rating',
    '.jm-review-item__rating-row',
    '.jdgm-carousel-item__review-rating-wrapper',
    '.jdgm-carousel__item-rating-row',
    '.jdgm-all-reviews__rating-row'
  ].join(', ');
  var DATE_SELECTOR = [
    '.jdgm-rev__timestamp',
    '.jdgm-rev__date',
    '.jm-review-item__timestamp',
    '.jm-review-item__date',
    '.jdgm-carousel-item__timestamp',
    '.jdgm-carousel-item__date',
    '.jdgm-carousel__item-timestamp',
    '.jdgm-carousel__item-date',
    '.jdgm-all-reviews__date',
    '.jm-reviewer-info__date',
    '.jm-reviewer-info__details > .jm-cluster:nth-child(2) .jm-text',
    '[itemprop="datePublished"]',
    'time[datetime]',
    '[data-review-date]',
    '[data-created-at]'
  ].join(', ');

  function toNumber(value) {
    var number = Number(String(value || '').replace(/[^0-9.]/g, ''));
    return Number.isFinite(number) ? number : 0;
  }

  function formatCount(value) {
    var number = toNumber(value);
    if (!number) return '';
    return Math.round(number).toLocaleString();
  }

  function getHost(section) {
    return (section && section.querySelector(HOST_SELECTOR)) || section;
  }

  function getWidget(section) {
    var host = getHost(section);
    if (!host) return null;
    return host.querySelector(WIDGET_SELECTOR) || host;
  }

  function getNativeRoot(widget) {
    return (widget && widget.querySelector('.jdgm-rev-widg, .jm-review-widget, .jdgm-carousel-wrapper')) || widget;
  }

  function getProductId(widget) {
    if (!widget) return '';
    var node = widget.matches && widget.matches('[data-id], [data-product-id]')
      ? widget
      : widget.querySelector('[data-id], [data-product-id]');
    return node && (node.getAttribute('data-id') || node.getAttribute('data-product-id'));
  }

  function getReviewWidgetData(widget) {
    var id = getProductId(widget);
    var data = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;

    if (data && id && data[id]) return data[id];

    if (data && id) {
      var keys = Object.keys(data);
      for (var i = 0; i < keys.length; i += 1) {
        var item = data[keys[i]];
        if (String(item && item.product_external_id) === String(id)) return item;
      }
    }

    return null;
  }

  function readTextNumber(node) {
    return toNumber(node && node.textContent);
  }

  function getAverageRating(widget, nativeRoot, data) {
    var average = Number(
      (data && (data.average_rating || data.average)) ||
      (nativeRoot && nativeRoot.getAttribute('data-average-rating')) ||
      (widget && widget.getAttribute('data-average-rating')) ||
      (widget && widget.getAttribute('data-shop-average-rating')) ||
      readTextNumber(widget && widget.querySelector('.jdgm-rev-widg__summary-average, .jdgm-all-reviews-rating, .jdgm-prev-badge__stars'))
    );

    return Number.isFinite(average) && average > 0 ? average : 0;
  }

  function getReviewCount(widget, nativeRoot, data) {
    var count = Number(
      (data && (data.number_of_reviews || data.review_count)) ||
      (nativeRoot && nativeRoot.getAttribute('data-number-of-reviews')) ||
      (widget && widget.getAttribute('data-number-of-reviews')) ||
      (widget && widget.getAttribute('data-shop-review-count')) ||
      readTextNumber(widget && widget.querySelector('.jdgm-rev-widg__summary-text, .jdgm-all-reviews-text, .jdgm-prev-badge__text'))
    );

    return Number.isFinite(count) && count > 0 ? count : 0;
  }

  function getHistogram(widget, data, total, average) {
    var rows = [];

    if (data && Array.isArray(data.histogram) && data.histogram.length) {
      data.histogram.forEach(function (row) {
        rows.push({
          rating: Number(row.rating),
          frequency: Number(row.frequency || row.count || 0),
          percent: Number(row.percentage || row.percent || 0)
        });
      });
    }

    if (!rows.length && widget) {
      widget.querySelectorAll('.jdgm-histogram__row[data-rating], .jm-histogram-row[data-rating]').forEach(function (row) {
        var ratingAttr = row.getAttribute('data-rating');
        if (!ratingAttr || ratingAttr === 'null') return;

        var rating = Number(ratingAttr);
        var frequency = Number(row.getAttribute('data-frequency') || row.getAttribute('data-count') || 0);
        var percent = Number(row.getAttribute('data-percentage') || row.getAttribute('data-percent') || 0);

        if (!frequency) frequency = readTextNumber(row.querySelector('.jdgm-histogram__frequency, .jm-histogram-row__count'));
        if (!percent && total && frequency) percent = Math.round((frequency / total) * 100);

        if (rating >= 1 && rating <= 5) rows.push({ rating: rating, frequency: frequency || 0, percent: percent || 0 });
      });
    }

    var byRating = rows.reduce(function (acc, row) {
      if (row.rating >= 1 && row.rating <= 5) {
        acc[row.rating] = {
          frequency: Number(row.frequency || 0),
          percent: Number(row.percent || 0)
        };
      }
      return acc;
    }, {});

    var hasAnyValue = false;
    var result = [5, 4, 3, 2, 1].map(function (rating) {
      var item = byRating[rating] || { frequency: 0, percent: 0 };
      var percent = item.percent || (total > 0 ? Math.round((item.frequency / total) * 100) : 0);
      percent = Math.max(0, Math.min(100, percent));
      if (percent > 0) hasAnyValue = true;
      return { rating: rating, percent: percent };
    });

    if (!hasAnyValue && total > 0) {
      var rounded = Math.max(1, Math.min(5, Math.round(average || 5)));
      result = result.map(function (row) {
        return { rating: row.rating, percent: row.rating === rounded ? 100 : 0 };
      });
    }

    return result;
  }

  function getOverviewMount(section, widget, nativeRoot) {
    var sectionOverview = section && section.querySelector(':scope .scentell-jdgm-overview[data-scentell-overview-fallback]');
    if (sectionOverview) return { overview: sectionOverview, parent: sectionOverview.parentNode };

    var direct = nativeRoot && nativeRoot.querySelector(':scope > .scentell-jdgm-overview');
    if (direct) return { overview: direct, parent: nativeRoot };

    var header = widget && widget.querySelector('.jdgm-rev-widg__header, .jm-review-widget-minimal-header, .jdgm-row-stars');
    var headerOverview = header && header.querySelector(':scope > .scentell-jdgm-overview');
    if (headerOverview) return { overview: headerOverview, parent: header };

    return { overview: null, parent: nativeRoot || widget };
  }

  function updateOverview(section, widget) {
    if (!widget) return;

    var nativeRoot = getNativeRoot(widget);
    var data = getReviewWidgetData(widget);
    var average = getAverageRating(widget, nativeRoot, data);
    var count = getReviewCount(widget, nativeRoot, data);

    /* Keep the editor fallback instead of replacing it with empty Judge.me data. */
    if (!average && !count) return;

    var histogram = getHistogram(widget, data, count, average);
    var countText = count
      ? formatCount(count) + (count === 1 ? ' verified review' : ' verified reviews')
      : 'Verified reviews';
    var averageText = average ? average.toFixed(1) : '5.0';

    var mount = getOverviewMount(section, widget, nativeRoot);
    if (!mount.parent) return;

    var signature = averageText + '|' + countText + '|' + histogram.map(function (row) {
      return row.rating + ':' + row.percent;
    }).join(',');

    var overview = mount.overview || document.createElement('div');
    overview.className = 'scentell-jdgm-overview';

    if (overview.getAttribute('data-scentell-signature') !== signature) {
      overview.setAttribute('data-scentell-signature', signature);
      overview.innerHTML = [
        '<div class="scentell-jdgm-score-wrap">',
          '<p class="scentell-jdgm-score">' + averageText + '</p>',
          '<div class="scentell-jdgm-stars" aria-hidden="true">✦✦✦✦✦</div>',
          '<div class="scentell-jdgm-count">' + countText + '</div>',
        '</div>',
        '<div class="scentell-jdgm-histogram" aria-hidden="true">',
          histogram.map(function (row) {
            return [
              '<div class="scentell-jdgm-histogram-row">',
                '<span class="scentell-jdgm-histogram-label">' + row.rating + '<span class="star">★</span></span>',
                '<span class="scentell-jdgm-bar" style="--bar-width: ' + row.percent + '%"></span>',
                '<span class="scentell-jdgm-histogram-value">' + row.percent + '%</span>',
              '</div>'
            ].join('');
          }).join(''),
        '</div>'
      ].join('');
    }

    if (!mount.overview) mount.parent.insertBefore(overview, mount.parent.firstChild);
  }

  function getReviewItems(widget) {
    if (!widget) return [];
    return Array.prototype.slice.call(widget.querySelectorAll(REVIEW_SELECTOR)).filter(function (card) {
      return !card.closest('.scentell-jdgm-overview');
    });
  }

  function getCleanText(node) {
    return String((node && node.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function cleanAuthorName(text) {
    return String(text || '')
      .replace(/Verified\s+Buyer/ig, '')
      .replace(/Verified\s+Customer/ig, '')
      .replace(/Verified/ig, '')
      .replace(/[·|]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getReviewAuthorName(card) {
    var authorNode = card.querySelector(AUTHOR_SELECTOR);
    var name = cleanAuthorName(getCleanText(authorNode));

    if (!name) {
      var wrapper = card.querySelector(AUTHOR_BLOCK_SELECTOR);
      name = cleanAuthorName(getCleanText(wrapper));
    }

    return name || 'Verified Customer';
  }

  function getReviewContentTarget(card) {
    return (
      card.querySelector('.jdgm-rev__content') ||
      card.querySelector('.jm-review-item__content-wrap') ||
      card.querySelector('.jm-review-item__content') ||
      card.querySelector('.jdgm-carousel-item__review') ||
      card.querySelector('.jdgm-carousel__item-review') ||
      card.querySelector('.jdgm-all-reviews__review-content') ||
      card
    );
  }

  function normalizeDateText(value) {
    var raw = String(value || '').replace(/\s+/g, ' ').trim();
    if (!raw) return '';

    var existing = raw.match(/\b\d{1,2}[\/.\-]\d{1,2}[\/.\-]\d{2,4}\b/);
    if (existing) {
      var parts = existing[0].split(/[\/.\-]/);
      if (parts.length === 3) {
        return parts[0].padStart(2, '0') + '/' + parts[1].padStart(2, '0') + '/' + String(parts[2]).slice(-2);
      }
      return existing[0];
    }

    var iso = raw.match(/\b\d{4}-\d{2}-\d{2}\b/);
    if (iso) raw = iso[0];

    var date = new Date(raw);
    if (!Number.isNaN(date.getTime()) && date.getFullYear() > 2000) {
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var year = String(date.getFullYear()).slice(-2);
      return month + '/' + day + '/' + year;
    }

    return '';
  }

  function getNativeDateNode(card) {
    var nodes = Array.prototype.slice.call(card.querySelectorAll(DATE_SELECTOR));
    for (var i = 0; i < nodes.length; i += 1) {
      if (nodes[i].closest('[data-scentell-review-footer]')) continue;
      return nodes[i];
    }
    return null;
  }

  function findReviewArray(value, depth) {
    if (!value || depth > 3) return null;

    if (Array.isArray(value)) {
      var score = 0;
      value.slice(0, 3).forEach(function (item) {
        if (!item || typeof item !== 'object') return;
        if ('created_at' in item || 'date' in item || 'review_date' in item || 'body' in item || 'title' in item || 'rating' in item || 'reviewer_name' in item) score += 1;
      });
      return score ? value : null;
    }

    if (typeof value !== 'object') return null;

    var keys = Object.keys(value);
    for (var i = 0; i < keys.length; i += 1) {
      var result = findReviewArray(value[keys[i]], depth + 1);
      if (result) return result;
    }

    return null;
  }

  function getDataReviewDate(widget, index) {
    var data = getReviewWidgetData(widget);
    var reviews = findReviewArray(data, 0);
    var review = reviews && reviews[index];
    if (!review || typeof review !== 'object') return '';

    return normalizeDateText(
      review.created_at ||
      review.review_date ||
      review.date ||
      review.published_at ||
      review.updated_at ||
      review.createdAt
    );
  }

  function getReviewDateText(card, widget, index) {
    var nativeDate = getNativeDateNode(card);
    var text = '';

    if (nativeDate) {
      text = normalizeDateText(
        nativeDate.getAttribute('datetime') ||
        nativeDate.getAttribute('content') ||
        nativeDate.getAttribute('data-review-date') ||
        nativeDate.getAttribute('data-created-at') ||
        nativeDate.textContent
      );
    }

    if (!text) {
      text = normalizeDateText(
        card.getAttribute('data-review-date') ||
        card.getAttribute('data-created-at') ||
        card.getAttribute('data-date') ||
        card.getAttribute('data-timestamp')
      );
    }

    if (!text) text = getDataReviewDate(widget, index);

    return text;
  }

  function hideNativeDate(card) {
    card.querySelectorAll(DATE_SELECTOR).forEach(function (node) {
      if (!node.closest('[data-scentell-rating-date-row]')) {
        node.setAttribute('data-scentell-native-date-hidden', 'true');
        node.setAttribute('aria-hidden', 'true');
      }
    });
  }

  function ensureRatingDateRow(card, widget, index) {
    var dateText = getReviewDateText(card, widget, index);
    var rating = card.querySelector(RATING_SELECTOR);
    var row = card.querySelector('[data-scentell-rating-date-row]') || card.querySelector(RATING_ROW_SELECTOR);

    if (!row) {
      row = document.createElement('div');
      row.className = 'scentell-jdgm-rating-date-row';
      row.setAttribute('data-scentell-rating-date-row', 'true');

      var contentTarget = getReviewContentTarget(card);
      if (rating && contentTarget && contentTarget.contains(rating)) {
        contentTarget.insertBefore(row, contentTarget.firstChild);
        row.appendChild(rating);
      } else if (rating && rating.parentNode) {
        rating.parentNode.insertBefore(row, rating);
        row.appendChild(rating);
      } else {
        card.insertBefore(row, card.firstChild);
      }
    } else {
      row.classList.add('scentell-jdgm-rating-date-row');
      row.setAttribute('data-scentell-rating-date-row', 'true');
      if (rating && !row.contains(rating)) row.insertBefore(rating, row.firstChild);
    }

    if (dateText) {
      var date = row.querySelector('.scentell-jdgm-review-date');
      if (!date) {
        date = document.createElement('span');
        date.className = 'scentell-jdgm-review-date';
        row.appendChild(date);
      }
      if (date.textContent !== dateText) date.textContent = dateText;
    } else {
      var staleDate = row.querySelector('.scentell-jdgm-review-date');
      if (staleDate) staleDate.remove();
    }

    hideNativeDate(card);
  }

  function hideNativeAuthorBlocks(card) {
    card.querySelectorAll(AUTHOR_BLOCK_SELECTOR).forEach(function (node) {
      if (!node.closest('[data-scentell-review-footer]')) {
        node.setAttribute('data-scentell-native-profile-hidden', 'true');
        node.setAttribute('aria-hidden', 'true');
      }
    });

    card.querySelectorAll('.jdgm-rev__buyer-badge-wrapper, .jm-verified-buyer-badge, .jdgm-verified-badge, .jdgm-carousel-item__verified-badge, .scentell-jdgm-verified-label').forEach(function (node) {
      if (!node.closest('[data-scentell-review-footer]')) node.remove();
    });
  }

  function ensureVerifiedFooter(card) {
    if (!card) return;

    var authorName = getReviewAuthorName(card);
    var target = getReviewContentTarget(card);
    if (!target) return;

    var footer = target.querySelector(':scope > [data-scentell-review-footer]') || card.querySelector('[data-scentell-review-footer]');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'scentell-jdgm-review-footer';
      footer.setAttribute('data-scentell-review-footer', 'true');
      target.appendChild(footer);
    } else if (footer.parentNode !== target) {
      target.appendChild(footer);
    }

    var author = footer.querySelector('.scentell-jdgm-author-name');
    if (!author) {
      author = document.createElement('strong');
      author.className = 'scentell-jdgm-author-name';
      footer.appendChild(author);
    }
    if (author.textContent !== authorName) author.textContent = authorName;

    var label = footer.querySelector('.scentell-jdgm-verified-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'scentell-jdgm-verified-label';
      footer.appendChild(label);
    }
    if (label.textContent !== 'Verified Buyer') label.textContent = 'Verified Buyer';

    card.classList.add('scentell-jdgm-has-verified-label');
  }

  function removeJudgeMeSpinners(root) {
    if (!root) return;
    root.querySelectorAll('.jdgm-spinner, .jdgm-rev-widg__paginate-spinner-wrapper, .jdgm-rev__icon, .jm-review-item__avatar, .jdgm-carousel-item__reviewer-image').forEach(function (node) {
      node.remove();
    });
  }

  function hideDuplicateNativeOverview(section, widget) {
    if (!section || !widget) return;
    widget.querySelectorAll('.scentell-jdgm-overview').forEach(function (overview) {
      if (!overview.hasAttribute('data-scentell-overview-fallback')) {
        overview.setAttribute('hidden', 'hidden');
        overview.style.display = 'none';
      }
    });
  }

  function normalizeReviewCard(card, widget, index) {
    if (!card) return;

    removeJudgeMeSpinners(card);
    ensureRatingDateRow(card, widget, index);
    hideNativeAuthorBlocks(card);
    ensureVerifiedFooter(card);

    card.setAttribute('data-scentell-normalized', 'true');
  }

  function normalizeReviewCards(widget) {
    getReviewItems(widget).forEach(function (card, index) {
      normalizeReviewCard(card, widget, index);
    });
  }

  function getNativeLoadMore(widget) {
    if (!widget) return null;

    var selectors = [
      '.jdgm-paginate__next-page:not(.jdgm-disabled):not([disabled])',
      '.jdgm-paginate__load-more:not(.jdgm-disabled):not([disabled])',
      '.jdgm-rev-widg__load-more:not(.jdgm-disabled):not([disabled])',
      '.jm-load-more:not(.jdgm-disabled):not([disabled])',
      '.jdgm-load-more:not(.jdgm-disabled):not([disabled])',
      'button[data-load-more]:not([disabled])',
      'a[data-load-more]'
    ].join(', ');

    return widget.querySelector(selectors);
  }

  function buildReadAllButton(section, widget) {
    if (!section || !widget || section.querySelector('.scentell-jdgm-read-all-wrap')) return;

    var items = getReviewItems(widget);
    if (!items.length) return;

    var nativeRoot = getNativeRoot(widget);
    var data = getReviewWidgetData(widget);
    var count = getReviewCount(widget, nativeRoot, data) || items.length;
    var label = section.getAttribute('data-read-all-label') || '';
    if (!label || label.toLowerCase() === 'read all reviews') {
      label = 'Read all ' + formatCount(count) + ' reviews';
    }

    /*
      Mobile only shows the first two review rows in the design, while desktop can
      show four cards before the CTA. Keeping the same collapsed class is safe on
      desktop because the desktop CSS only hides item 5+.
    */
    var shouldCollapse = items.length > 2;
    var hasMoreAvailable = count > items.length;
    var nativeMore = getNativeLoadMore(widget);

    if (!shouldCollapse && !hasMoreAvailable && !nativeMore) return;

    if (shouldCollapse) {
      section.classList.add('scentell-jdgm-collapsed');
      widget.classList.add('scentell-jdgm-collapsed');
    }

    var wrap = document.createElement('div');
    wrap.className = 'scentell-jdgm-read-all-wrap';

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'scentell-jdgm-read-all';
    button.textContent = label;
    button.addEventListener('click', function () {
      section.classList.remove('scentell-jdgm-collapsed');
      widget.classList.remove('scentell-jdgm-collapsed');

      var latestNativeMore = getNativeLoadMore(widget);
      if (latestNativeMore) {
        latestNativeMore.click();
        window.setTimeout(function () {
          normalizeReviewCards(widget);
          if (!getNativeLoadMore(widget) && getReviewItems(widget).length >= count) {
            wrap.remove();
          }
        }, 700);
        return;
      }

      wrap.remove();
    });

    wrap.appendChild(button);
    var inner = section.querySelector('.smp-judgeme-proof__inner') || section;
    inner.appendChild(wrap);
  }

  function enhanceSection(section) {
    if (!section) return;
    var widget = getWidget(section);
    if (!widget) return;

    hideDuplicateNativeOverview(section, widget);
    removeJudgeMeSpinners(widget);
    updateOverview(section, widget);
    normalizeReviewCards(widget);
    buildReadAllButton(section, widget);
  }

  function enhanceAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(enhanceSection);
  }

  function scheduleEnhance() {
    if (scheduleEnhance.queued) return;
    scheduleEnhance.queued = true;
    window.requestAnimationFrame(function () {
      scheduleEnhance.queued = false;
      enhanceAll();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  var attempts = 0;
  var timer = window.setInterval(function () {
    enhanceAll();
    attempts += 1;
    if (attempts >= 80) window.clearInterval(timer);
  }, 250);

  var observer = new MutationObserver(scheduleEnhance);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  window.setTimeout(function () {
    observer.disconnect();
  }, 20000);

  document.addEventListener('shopify:section:load', function (event) {
    if (event && event.target) {
      event.target.querySelectorAll(SECTION_SELECTOR).forEach(enhanceSection);
    }
  });
})();
